var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SAUX360Theme } from '../theme';
import { responsiveStyles, getBreakpoints } from '../utilities/responsive-styles';
import { isSeparatorValue } from '../utilities/types.utilities';
// Types for responsive props
var breakpointLabels = ['xs', 'sm', 'md', 'lg', 'xl'];
var paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
];
var marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
];
// Checks if spacing value is a theme value or basic string value
export function getSpacing(spacingValue, theme) {
    if (typeof spacingValue === 'string' && isSeparatorValue(spacingValue)) {
        return theme === null || theme === void 0 ? void 0 : theme.size.spacer[spacingValue];
    }
    return (spacingValue === null || spacingValue === void 0 ? void 0 : spacingValue.toString()) || '';
}
var StyledBox = styled.div.attrs(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return props;
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme, p = props.p, py = props.py, pt = props.pt, px = props.px, pr = props.pr, pb = props.pb, pl = props.pl, m = props.m, my = props.my, mt = props.mt, mx = props.mx, mr = props.mr, mb = props.mb, ml = props.ml, s = props.s, st = props.st, sr = props.sr, sb = props.sb, sl = props.sl, sx = props.sx, sy = props.sy, displayProp = props.displayProp;
    // Padding
    var paddingTopProp = pt || py || p;
    var paddingTop = getBreakpoints(paddingTopProp);
    var paddingRightProp = pr || px || p;
    var paddingRight = getBreakpoints(paddingRightProp);
    var paddingBottomProp = pb || py || p;
    var paddingBottom = getBreakpoints(paddingBottomProp);
    var paddingLeftProp = pl || px || p;
    var paddingLeft = getBreakpoints(paddingLeftProp);
    // Margin
    var marginTopProp = mt || my || m;
    var marginTop = getBreakpoints(marginTopProp);
    var marginRightProp = mr || mx || m;
    var marginRight = getBreakpoints(marginRightProp);
    var marginBottomProp = mb || my || m;
    var marginBottom = getBreakpoints(marginBottomProp);
    var marginLeftProp = ml || mx || m;
    var marginLeft = getBreakpoints(marginLeftProp);
    // Border
    var borderTop = st || sy || s;
    var borderRight = sr || sx || s;
    var borderBottom = sb || sy || s;
    var borderLeft = sl || sx || s;
    var borderStyle = 'solid';
    var display = displayProp;
    // Return styles dynamically
    return "\n    " + (display && responsiveStyles(display)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), function (displayValue) { return displayValue; })) + "\n    " + (paddingTop && responsiveStyles(paddingTop)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        padding-top: ", ";\n      "], ["\n        padding-top: ", ";\n      "])), function (paddingValue) { return getSpacing(paddingValue, theme); })) + "\n    " + (paddingBottom && responsiveStyles(paddingBottom)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        padding-bottom: ", ";\n      "], ["\n        padding-bottom: ", ";\n      "])), function (paddingValue) { return getSpacing(paddingValue, theme); })) + "\n    " + (paddingRight && responsiveStyles(paddingRight)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        padding-right: ", ";\n      "], ["\n        padding-right: ", ";\n      "])), function (paddingValue) { return getSpacing(paddingValue, theme); })) + "\n    " + (paddingLeft && responsiveStyles(paddingLeft)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        padding-left: ", ";\n      "], ["\n        padding-left: ", ";\n      "])), function (paddingValue) { return getSpacing(paddingValue, theme); })) + "\n    " + (marginTop && responsiveStyles(marginTop)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        margin-top: ", ";\n      "], ["\n        margin-top: ", ";\n      "])), function (marginValue) { return getSpacing(marginValue, theme); })) + "\n    " + (marginBottom && responsiveStyles(marginBottom)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        margin-bottom: ", ";\n      "], ["\n        margin-bottom: ", ";\n      "])), function (marginValue) { return getSpacing(marginValue, theme); })) + "\n    " + (marginRight && responsiveStyles(marginRight)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        margin-right: ", ";\n      "], ["\n        margin-right: ", ";\n      "])), function (marginValue) { return getSpacing(marginValue, theme); })) + "\n    " + (marginLeft && responsiveStyles(marginLeft)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        margin-left: ", ";\n      "], ["\n        margin-left: ", ";\n      "])), function (marginValue) { return getSpacing(marginValue, theme); })) + "\n      " + (borderTop
        ? "border-top: " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderTop].thickness) + "\n          " + borderStyle + "\n          " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderTop].color) + ";\n        "
        : '') + "\n      " + (borderRight
        ? "border-right: " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderRight].thickness) + "\n          " + borderStyle + "\n          " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderRight].color) + ";\n        "
        : '') + "\n      " + (borderBottom
        ? "border-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderBottom].thickness) + "\n          " + borderStyle + "\n          " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderBottom].color) + ";\n        "
        : '') + "\n      " + (borderLeft
        ? "border-left: " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderLeft].thickness) + "\n          solid\n          " + (theme === null || theme === void 0 ? void 0 : theme.separator[borderLeft].color) + ";\n        "
        : '') + "\n    ";
});
/** `Box` is a layout component that handles many utility needs. */
export function SABox(_a) {
    var component = _a.component, children = _a.children, m = _a.m, mt = _a.mt, mr = _a.mr, mb = _a.mb, ml = _a.ml, mx = _a.mx, my = _a.my, margin = _a.margin, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginX = _a.marginX, marginY = _a.marginY, p = _a.p, pt = _a.pt, pr = _a.pr, pb = _a.pb, pl = _a.pl, px = _a.px, py = _a.py, padding = _a.padding, paddingTop = _a.paddingTop, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, paddingX = _a.paddingX, paddingY = _a.paddingY, s = _a.s, st = _a.st, sr = _a.sr, sb = _a.sb, sl = _a.sl, sx = _a.sx, sy = _a.sy, separator = _a.separator, separatorTop = _a.separatorTop, separatorRight = _a.separatorRight, separatorBottom = _a.separatorBottom, separatorLeft = _a.separatorLeft, separatorX = _a.separatorX, separatorY = _a.separatorY, display = _a.display, flex = _a.flex, className = _a.className, dataTestId = _a["data-testid"], theme = _a.theme, rest = __rest(_a, ["component", "children", "m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "s", "st", "sr", "sb", "sl", "sx", "sy", "separator", "separatorTop", "separatorRight", "separatorBottom", "separatorLeft", "separatorX", "separatorY", "display", "flex", "className", 'data-testid', "theme"]);
    // allow to customize parent element
    var Tag = component;
    return (React.createElement(StyledBox, __assign({ as: Tag, m: m || margin, mt: mt || marginTop, mr: mr || marginRight, mb: mb || marginBottom, ml: ml || marginLeft, mx: mx || marginX, my: my || marginY, p: p || padding, pt: pt || paddingTop, pr: pr || paddingRight, pb: pb || paddingBottom, pl: pl || paddingLeft, px: px || paddingX, py: py || paddingY, s: s || separator, st: st || separatorTop, sr: sr || separatorRight, sb: sb || separatorBottom, sl: sl || separatorLeft, sx: sx || separatorX, sy: sy || separatorY, displayProp: getBreakpoints(display), flex: flex, className: className, "data-testid": dataTestId || 'Box', theme: theme }, rest), children));
}
SABox.defaultProps = {
    component: 'div',
    display: undefined,
    flex: undefined,
    className: undefined,
    theme: SAUX360Theme,
};
StyledBox.defaultProps = {
    theme: SAUX360Theme,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=box.component.js.map